var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0.5C6.36819 0.5 6.66667 0.798477 6.66667 1.16667V7.55719L8.86193 5.36193C9.12228 5.10158 9.54439 5.10158 9.80474 5.36193C10.0651 5.62228 10.0651 6.04439 9.80474 6.30474L6.4714 9.63807C6.21105 9.89842 5.78894 9.89842 5.5286 9.63807L2.19526 6.30474C1.93491 6.04439 1.93491 5.62228 2.19526 5.36193C2.45561 5.10158 2.87772 5.10158 3.13807 5.36193L5.33333 7.55719V1.16667C5.33333 0.798477 5.63181 0.5 6 0.5ZM0.666667 9.16667C1.03486 9.16667 1.33333 9.46514 1.33333 9.83333V11.1667C1.33333 11.3435 1.40357 11.513 1.5286 11.6381C1.65362 11.7631 1.82319 11.8333 2 11.8333H10C10.1768 11.8333 10.3464 11.7631 10.4714 11.6381C10.5964 11.513 10.6667 11.3435 10.6667 11.1667V9.83333C10.6667 9.46514 10.9651 9.16667 11.3333 9.16667C11.7015 9.16667 12 9.46514 12 9.83333V11.1667C12 11.6971 11.7893 12.2058 11.4142 12.5809C11.0391 12.956 10.5304 13.1667 10 13.1667H2C1.46957 13.1667 0.960859 12.956 0.585786 12.5809C0.210714 12.2058 0 11.6971 0 11.1667V9.83333C0 9.46514 0.298477 9.16667 0.666667 9.16667Z",
    fill: "#33CC99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.4a148e83e6f2050167f217a161a05caf.svg";
export { ForwardRef as ReactComponent };